var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "individuals__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('IndividualCard', {
      key: result.id,
      staticClass: "individuals__individual",
      attrs: {
        "person": result
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583ee9f3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-individuals.vue
// module id = null
// module chunks = 